@if (useStandard) {
  <crm-standard-multi-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValues]="filialIds !== null ? null : selectedFilials"
    [selectedKeys]="filialIds"
    (selectedValuesChange)="onSelected($event)"
    [filtersUiVersion]="filtersUiVersion"
    [labelInput]="isFloatLabel"
    labelInputText="Филиал"
    [placeholder]="placeholder"
    [display]="display"
    [showClear]="showClear"
    [class]="class"
    [styleClass]="styleClass"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-multi-select>
} @else {
  <crm-multi-select
    [filtersUiVersion]="filtersUiVersion"
    [styleClass]="styleClass"
    [class]="class"
    [label]="isFloatLabel ? 'Филиал' : ''"
    [showClear]="showClear"
    [appendTo]="appendTo"
    [options]="filials"
    [disabled]="disabled"
    [display]="display"
    [sort]="sort"
    [placeholder]="placeholder"
    [isError]="isError"
    [selectedItems]="selectedFilials"
    (selectedItemsChange)="onSelected($event)"
    [loading]="loading || selectionLoading"></crm-multi-select>
}
